import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import AllThumbnail from "./SellerComp/AllThumbnail";
import EditListingNavbar from "./SellerComp/EditListingNavbar";
import AllDocument from "./SellerComp/AllDocument";

const ListingCatelog = () => {
  const [formData, setFormData] = useState({
    file: null, // Supports multiple file types
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { listing_id, seller_id } = useParams();

  // Allowed file types
  const acceptedFileTypes = {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
    "application/vnd.ms-powerpoint": [".ppt"],
    "image/*": [],
    "video/*": []
  };

  // File Upload Handling
  const onFileDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFormData({ file: acceptedFiles[0] });
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onFileDrop,
    accept: Object.keys(acceptedFileTypes).join(","),
    multiple: false,
  });

  const validateForm = () => {
    let formErrors = {};
    if (!formData.file) formErrors.file = "A file is required.";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (validateForm()) {
      const formSubmission = new FormData();
      formSubmission.append("document", formData.file); // ✅ Ensure correct field name
      formSubmission.append("listing_id", seller_id);
      formSubmission.append("listing_product_id", listing_id);
  
      console.log("🚀 Sent Data:");
      for (let [key, value] of formSubmission.entries()) {
        console.log(`${key}:`, value);
      }
  
      try {
        const response = await axios.post(
          `${baseurl}uploadDocument`,
          formSubmission,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
  
        if (response.status === 201) {
          Swal.fire({
            icon: "success",
            title: "File Uploaded Successfully!",
            text: "Your file has been uploaded and linked to the listing.",
            confirmButtonText: "Ok",
          }).then(() => window.location.reload());
        } else {
          Swal.fire({
            icon: "error",
            title: "Upload Failed!",
            text: "There was an error uploading the file. Please try again.",
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.log("❌ Upload Error:", error);
        Swal.fire({
          icon: "error",
          title: "Upload Failed!",
          text: "An error occurred while uploading the file. Please try again.",
          confirmButtonText: "Ok",
        });
      }
    }
  };
  
  


  // File Preview
  const getFilePreview = () => {
    if (!formData.file) return null;

    const fileType = formData.file.type;
    if (fileType.startsWith("image/")) {
      return <img src={URL.createObjectURL(formData.file)} alt="Preview" className="preview-image" />;
    } else if (fileType.startsWith("video/")) {
      return <video src={URL.createObjectURL(formData.file)} controls className="preview-video" />;
    } else {
      return <p className="file-name-preview">{formData.file.name}</p>;
    }
  };

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <EditListingNavbar />

                <div className="reviewcls text-start">
                  <h4 className="selh1">Upload Listing Catelogs</h4>
                  <hr />

                  <div className="row g-3">
                   

                    <div className="col-md-3">
                      <form onSubmit={handleSubmit}>
                        <div className="row g-2">
                          <div className="col-md-12">
                            <div
                              {...getRootProps({
                                className: "dropzone",
                                style: {
                                  border: "2px dashed #ccc",
                                  padding: "20px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  width: "200px",
                                  height: "200px",
                                  position: "relative",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                                },
                              })}
                            >
                              <input {...getInputProps()} />
                              <p>Drag & drop a file here, or click to select</p>
                              {getFilePreview()}
                            </div>
                            {errors.file && <small className="text-danger">{errors.file}</small>}
                          </div>

                          <div className="col-md-12 mt-3 text-start">
                            <button type="submit" className="btn btn-primary" disabled={!formData.file}>
                              Upload File
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="col-md-9">
                      <AllDocument/>
                    </div>


                  </div>              
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ListingCatelog;
